import React from "react";
import { graphql } from "gatsby";
import Container from "../components/container";
import GraphQLErrorList from "../components/graphql-error-list";
import BlogPost from "../components/blog-post";
import SEO from "../components/seo";
import Layout from "../containers/layout";
import { toPlainText, mergeMenuRawItems } from "../lib/helpers";

export const query = graphql`
  query BlogPostTemplateQuery($id: String!) {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      hotlineNumber
    }
    mainMenu: sanityNavigationMenu(title: { eq: "Main nav menu" }) {
      id
      _key
      title
      ...NavMenu
    }
    post: sanityPost(id: { eq: $id }) {
      id
      publishedAt
      structuredSEO {
        jsonString
      }
      categories {
        _id
        title
      }
      mainImage {
        ...SanityImage
        alt
      }
      title
      slug {
        current
      }
      _rawExcerpt(resolveReferences: { maxDepth: 5 })
      _rawBody(resolveReferences: { maxDepth: 5 })
      authors {
        _key
        author {
          image {
            crop {
              _key
              _type
              top
              bottom
              left
              right
            }
            hotspot {
              _key
              _type
              x
              y
              height
              width
            }
            asset {
              _id
            }
          }
          name
        }
      }
    }
  }
`;

const BlogPostTemplate = (props) => {
  const { data, errors } = props;
  const post = data && data.post;
  const structuredSEO = post.structuredSEO || {};
  const site = data && data.site;
  const mainMenu = mergeMenuRawItems(data?.mainMenu || {});
  return (
    <Layout navMenuItems={(mainMenu || {}).items || []} hotlineNumber={site.hotlineNumber}>
      {errors && <SEO title="GraphQL Error" />}
      {post && (
        <SEO
          title={post.title || "Untitled"}
          description={toPlainText(post._rawExcerpt)}
          image={post.mainImage}
        />
      )}

      {structuredSEO?.jsonString && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: structuredSEO?.jsonString || "" }}
        />
      )}

      {errors && (
        <Container>
          <GraphQLErrorList errors={errors} />
        </Container>
      )}

      {post && <BlogPost {...post} />}
    </Layout>
  );
};

export default BlogPostTemplate;
